import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-tech-recruitment4',
  templateUrl: './tech-recruitment4.component.html',
  styleUrls: ['./tech-recruitment4.component.scss']
})
export class TechRecruitment4Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
